module.exports = __webpack_public_path__ + "static/media/get-involved--donate-landscape.8718bf2a.jpg";